<template>
    <div class="loader">
        <div class="container">
            <div class="animation"></div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="css" scoped>

    .mobile-filter-hide .loader{
        padding-top: 0;
        width: auto;
    }
    .loader {
        width: 100%;
        padding-top: 28%;
        z-index: 9999;
    }
    .loader .container {
        width: 70px;
        height: 35px;
        overflow: hidden;
        margin: 0 auto;
    }

    .mobile-filter-hide .loader .container .animation{
        width: 30px;
        height: 30px;
    }

    .loader .container .animation {    
        width: 70px;
        height: 70px;
        border-style: solid;
        border-top-color: rgb(32, 32, 32);
        border-right-color: rgb(32, 32, 32);
        border-left-color: transparent;
        border-bottom-color: transparent;
        border-radius: 50%;
        box-sizing: border-box;
        animation: rotate 3s ease-in-out infinite;
        transform: rotate(-200deg);
    }
    @keyframes rotate {
        0% { border-width: 10px; }
        25% { border-width: 3px; }
        50% { 
            transform: rotate(115deg); 
            border-width: 10px;
        }
        75% { border-width: 3px;}
        100% { border-width: 10px;}
    }
    
</style>




// WEBPACK FOOTER //
// resources/assets/js/site/components/loader.vue